// OpenAI Assistants API response interfaces
// Based on: https://platform.openai.com/docs/api-reference/assistants

export interface IOpenAIThread {
	id: string;
	object: 'thread';
	created_at: number;
	metadata: Record<string, any>;
}

export interface IOpenAIMessage {
	id: string;
	object: 'thread.message';
	created_at: number;
	thread_id: string;
	role: 'user' | 'assistant';
	content: IOpenAIMessageContent[];
	assistant_id: string | null;
	run_id: string | null;
	metadata: Record<string, any>;
}

export interface IOpenAIMessageContent {
	type: 'text' | 'image_file' | 'image_url';
	text?: {
		value: string;
		annotations: any[];
	};
	image_file?: {
		file_id: string;
	};
	image_url?: {
		url: string;
	};
}

export interface IOpenAIRun {
	id: string;
	object: 'thread.run';
	created_at: number;
	thread_id: string;
	assistant_id: string;
	status: 'queued' | 'in_progress' | 'requires_action' | 'cancelling' | 'cancelled' | 'failed' | 'completed' | 'expired';
	required_action: any | null;
	last_error: any | null;
	expires_at: number;
	started_at: number | null;
	cancelled_at: number | null;
	failed_at: number | null;
	completed_at: number | null;
	model: string;
	instructions: string;
	tools: any[];
	metadata: Record<string, any>;
}

export interface IOpenAIListResponse<T> {
	object: 'list';
	data: T[];
	first_id: string;
	last_id: string;
	has_more: boolean;
}
